import { useQuery, skipToken } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  DashboardEntitiesSummaryParams,
  getDashboardMerchantsSummary,
} from 'config/requests/dashboard';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { EntitiesSummary } from 'types/embedded/dashboard';
import { ErrorData } from 'types/embedded/error';

export function useGetDashboardMerchantsSummary(params: DashboardEntitiesSummaryParams | null) {
  const translate = useTypedTranslate();

  const normalizedParams = params
    ? {
        periodFrom: params.periodFrom,
        periodTo: params.periodTo,
        timezone: params.timezone,
      }
    : null;

  const {
    data: summary,
    isLoading,
    isFetching,
    error,
  } = useQuery<EntitiesSummary, AxiosError<ErrorData>>({
    queryKey: ['dashboard/top_merchants', params],
    queryFn: normalizedParams ? () => getDashboardMerchantsSummary(normalizedParams) : skipToken,
  });

  const errorMessage = error
    ? error.response?.data?.errors?.[0].title || translate('app.common.serverError')
    : undefined;

  return { summary, isLoading, isFetching, error: errorMessage };
}

export type GetDashboardMerchantsSummaryResult = ReturnType<typeof useGetDashboardMerchantsSummary>;
